export const GET_INVENTORY_DETAIL_REQUESTED = "GET_INVENTORY_DETAIL_REQUESTED";
export const GET_INVENTORY_DETAIL_SUCCEEDED = "GET_INVENTORY_DETAIL_SUCCEEDED";
